var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6739 5.7895C12.1867 5.25138 11.4522 4.93869 10.4341 4.82961V4.27695C10.4341 3.2807 10.0124 2.32081 9.27063 1.6518C8.52162 0.968238 7.54719 0.648275 6.5364 0.742809C4.79845 0.910063 3.3368 2.58987 3.3368 4.40784V4.82961C2.31874 4.93869 1.58427 5.25138 1.09706 5.7895C0.391685 6.57484 0.413501 7.62199 0.493491 8.34918L1.00252 12.3996C1.15523 13.8176 1.72971 15.272 4.85663 15.272H8.9143C12.0412 15.272 12.6157 13.8176 12.7684 12.4069L13.2774 8.34191C13.3574 7.62199 13.3792 6.57484 12.6739 5.7895ZM6.6382 1.7536C7.36539 1.68815 8.05622 1.91358 8.59434 2.4008C9.12519 2.88074 9.42334 3.5643 9.42334 4.27695V4.78598H4.34759V4.40784C4.34759 3.11345 5.41656 1.86995 6.6382 1.7536ZM6.88545 12.785C5.36566 12.785 4.12944 11.5488 4.12944 10.029C4.12944 8.50916 5.36566 7.27294 6.88545 7.27294C8.40527 7.27294 9.64149 8.50916 9.64149 10.029C9.64149 11.5488 8.40527 12.785 6.88545 12.785Z",
    fill: "#14AF14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47177 11.3755C6.33361 11.3755 6.19544 11.3246 6.08636 11.2155L5.36642 10.4956C5.15553 10.2847 5.15553 9.93563 5.36642 9.72475C5.57733 9.51386 5.92638 9.51386 6.13726 9.72475L6.48632 10.0738L7.64982 8.99756C7.86798 8.79395 8.21703 8.80849 8.42064 9.02665C8.62425 9.2448 8.60971 9.59385 8.39155 9.79747L6.84264 11.23C6.73356 11.3246 6.60267 11.3755 6.47177 11.3755Z",
    fill: "#14AF14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliever);
export default __webpack_public_path__ + "static/media/deliever.5aaf5c49644a3b7f837dc40fb86b8b4c.svg";
export { ForwardRef as ReactComponent };